const SENSITIVE_KEYS = new Set([
  'phone',
  'id_card',
  'real_name',
  'address',
  'bank_card',
  'mobile',
  'password',
  'token',
]);

export function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function createId(prefix: string): string {
  const rand =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID().replace(/-/g, '').slice(0, 16)
      : `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
  return `${prefix}_${rand}`;
}

export function sanitizeProperties(
  input: Record<string, unknown> | undefined
): Record<string, unknown> {
  if (!input) return {};
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (SENSITIVE_KEYS.has(key.toLowerCase())) continue;
    out[key] = value;
  }
  return out;
}

export function buildCollectUrl(endpoint: string, productId: string): string {
  try {
    const url = new URL(endpoint, isBrowser() ? window.location.origin : 'http://localhost');
    if (!url.searchParams.has('product_id')) {
      url.searchParams.set('product_id', productId);
    }
    return url.toString();
  } catch {
    const sep = endpoint.includes('?') ? '&' : '?';
    return `${endpoint}${sep}product_id=${encodeURIComponent(productId)}`;
  }
}

export function logDebug(enabled: boolean, ...args: unknown[]): void {
  if (!enabled) return;
  console.log('[tracking-sdk]', ...args);
}
